import { useContext } from 'react'
import SpaceContext from 'src/contexts/SpaceContext'

const useSpace = () => useContext(SpaceContext)

export default useSpace
